import { Container } from "../../elements/Container";
import { IItemProps, Item } from "./components/Item/Item";
import { styles } from "./UniqueSellingPointsBig.style";

export interface UniqueSellingPointsProps {
  title: string;
  subtitle?: string;
  type: string;
  items: IItemProps[];
}

export enum IconType {
  SMALL = "small icon",
  BIG = "big icon",
  IMAGE = "image",
}

export const UniqueSellingPointsBig = (props: UniqueSellingPointsProps) => {
  const { title, items, subtitle, type } = props;
  const isImageSize = type === IconType.IMAGE;

  return (
    <Container>
      <div className={styles.root(isImageSize)}>
        <h2 className={styles.title()}>{title}</h2>
        {subtitle && <span className={styles.subtitle()}>{subtitle}</span>}
        <div className={styles.itemsContainer()}>
          {items.map((item) => (
            <Item
              key={item.label}
              image={item.image}
              label={item.label}
              text={item.text}
              isImageSize={isImageSize}
              alt={item.alt}
            ></Item>
          ))}
        </div>
      </div>
    </Container>
  );
};
